<template>
    <b-modal v-model="internalShow" @hide="$emit('update:show', false)" :title="$t('pickup.sendLoadingList')">
        <div class="form-group">
            <label class="form-text">{{ $t('pickup.fields.email') }}<required-icon></required-icon></label>
            <input type="text" class="form-control" v-model="email"/>
            <span class="text-danger" v-if="errors['email']">{{ errors['email'][0] }}</span>
        </div>
        <template v-slot:modal-footer>
            <button class="btn btn-primary" @click="sendLoadingList">{{ $t('pickup.sendLoadingList') }}</button>
        </template>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
    name: 'PickupLoadingListModal',
    components: { BModal },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        pickup: {
            type: Object,
            required: true
        },
    },
    data: function () {
        return {
            internalShow: false,
            email: null,
            errors: []
        }
    },
    watch: {
        show: {
            handler: function (val) {
                this.internalShow = val
            },
            immediate: true
        },
    },
    methods: {
        sendLoadingList(){
            axios.post('/pickup/' + this.pickup.id + '/send-loading-list', {email: this.email}).then(response => {
                this.$saveSuccess();
                this.internalShow = false;
            }).catch((err) => {
                this.errors = err.response.data.errors
            });
        }
    }
}
</script>
